import { useRef, useEffect } from 'react';

export const QUICK_REACTIONS = ['👍', '❤️', '😂', '😮', '😢', '🙏'] as const;

interface QuickReactionPickerProps {
  isOpen: boolean;
  onClose: () => void;
  onSelect: (emoji: string) => void;
  onOpenFull: () => void;
  anchorRef?: React.RefObject<HTMLElement | null>;
  align?: 'start' | 'end';
}

export default function QuickReactionPicker({
  isOpen,
  onClose,
  onSelect,
  onOpenFull,
  anchorRef,
  align = 'end',
}: QuickReactionPickerProps) {
  const pickerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!isOpen) return;

    const handleClickOutside = (event: MouseEvent) => {
      if (
        pickerRef.current &&
        !pickerRef.current.contains(event.target as Node) &&
        anchorRef?.current &&
        !anchorRef.current.contains(event.target as Node)
      ) {
        onClose();
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [isOpen, onClose, anchorRef]);

  if (!isOpen) return null;

  return (
    <div
      className={`quick-reaction-picker align-${align}`}
      ref={pickerRef}
    >
      {QUICK_REACTIONS.map((emoji) => (
        <button
          key={emoji}
          type="button"
          className="quick-reaction-btn"
          onClick={() => onSelect(emoji)}
          title={`Réagir avec ${emoji}`}
          aria-label={`Réagir avec ${emoji}`}
        >
          {emoji}
        </button>
      ))}
      <button
        type="button"
        className="quick-reaction-btn quick-reaction-more"
        onClick={onOpenFull}
        title="Plus d'émojis"
        aria-label="Plus d'émojis"
      >
        +
      </button>
    </div>
  );
}
